import Text from '@/common/components/atom/text';
import LegalPageLayout, { LegalPageTitle, LegalSectionCard, legalBodyStackClassName, legalCardBodyClassName } from '../components/legalPageLayout';

// Ported verbatim from the retired /home/about-us/ WordPress page.
const betterWorld = [
  'انسان‌ها در طول دوره زیسته خود، اثراتی کوچک یا بزرگ از خود بر روی این کره خاکی به جا می‌گذارند. این اثرات می‌تواند خواسته و گاه ناخواسته باشد؛ گاهی با برنامه پیش برود و گاهی بدون برنامه‌ریزی! اما انسان‌هایی که با برنامه قصد دارند منشا خیر و برکت برای جامعه باشند، عمدتا هدف دارند و برای زندگی خود رسالتی را تعیین کرده‌اند.',
  'با خود می‌اندیشم این رسالت‌ها به حدی زیباست که در کلمات نمی‌توان آن را توصیف کرد و واقعا مهم نیست این رسالت‌ها چقدر کوچک یا بزرگ باشند، ارزش واقعی و تاثیر فوق‌العاده آن‌ها را زمانی درک خواهیم کرد که دنیا را به جای بهتری برای زندگی انسان‌ها تبدیل کرده باشیم.',
  'اینجا در دل کویر و در یکی از زیباترین کشورهای دنیا، مردمان سخت‌کوش یزدی آب را با سختی فراوان از دل خاک تشنه بیرون کشیدند و حیات را به معنای واقعی کلمه جاری ساختند. اجداد ما ثابت کردند در هر شرایطی می‌توان عالی زیست و به زندگی معنا بخشید و دنیا را به جای بهتری برای زندگی تبدیل کرد.',
  'حالا از این نسل سخت‌کوش، جوانانی قد علم کرده و تصمیم گرفتند مسیر نیاکان خود را ادامه دهند و آن‌ها نیز منشا خیر، برکت و تحول برای مردمان سرزمینشان شوند. تیم جوانی که درد و رنج بیماران را درک کرده و عزم راسخ کردند تا بیماران به جز درد و رنج حاصل از بیماری، سختی شرایط طاقت‌فرسا را متحمل نشوند و لذت یک درمان به موقع و به دور از فرسایش را تجربه کنند. این امر رسالت و دلیل تلاش این جوانان شده است.',
];

const ourStory = [
  'من ابوالفضل ساجدی به همراه محمد رضا طباطبایی، محمد ابراهیم قانع و حامد صادقی نژاد سال ۱۳۹۴ دست در دست هم گذاشتیم و با یکدیگر عهد بستیم تا از رسالت خود دست نکشیم و تا توان داریم در راه عشق به هدف مقدس‌مان بکوشیم.',
  'حال که این متن را می‌نویسم نزدیک به پنجاه نفر از بهترین‌های این خاک با ما هم پیمان شدند و جلوتر از ما برای تحقق این هدف می‌کوشند.',
  'ما با عشق، گوشه‌ای از دنیای زیبا و مطلوب را ساختیم و در تلاشیم که آنچه ساختیم هر روز بهتر از دیروز باشد. امیدواریم شرایط زندگی برای شما به گونه‌ای رقم نخورد که به پذیرش۲۴ نیاز پیدا کنید و همیشه در صحت و سلامت باشید اما اگر این اتفاق افتاد، امیدوارم بتوانیم تجربه درمانی شیرین و رویایی را برای شما خلق کنیم.',
];

// Same order and links as the old page. There the Health Ministry licence link sat on a
// duplicate Budget Organization logo; it now carries the ministry's own logo.
const licenses = [
  { src: 'nezam-fanni.png', alt: 'نظام فنی و اجرایی کشور', href: 'https://sama.mporg.ir/sites/Publish/SitePages/Home.aspx' },
  { src: 'nezam-senfi.png', alt: 'سازمان نظام صنفی رایانه‌ای کشور', href: 'https://www.irannsr.org/fa/' },
  { src: 'mporg.png', alt: 'سازمان برنامه و بودجه کشور', href: 'https://www.mporg.ir/home' },
  { src: 'behdasht.png', alt: 'مرکز مدیریت آمار و فناوری اطلاعات وزارت بهداشت', href: 'http://pocsra.behdasht.gov.ir/PocsQuery?cid=8800108190' },
  { src: 'ict.png', alt: 'وزارت ارتباطات و فناوری اطلاعات', href: 'https://www.ict.gov.ir/' },
  { src: 'samandehi.png', alt: 'نشان ملی ثبت رسانه‌های دیجیتال' },
];

const Paragraphs = ({ items }: { items: string[] }) => (
  <div className={`${legalCardBodyClassName} ${legalBodyStackClassName}`}>
    {items.map(p => (
      <Text key={p} as="p" fontSize="sm" className="leading-7 text-slate-700 text-justify">
        {p}
      </Text>
    ))}
  </div>
);

const AboutUs = () => {
  return (
    <LegalPageLayout
      lang="fa"
      dir="rtl"
      headerVariant="plain"
      title={<LegalPageTitle>درباره ما</LegalPageTitle>}
      breadcrumbs={[
        { text: 'خانه', href: '/' },
        { text: 'درباره ما' },
      ]}
    >
      <LegalSectionCard title="دنیای بهتر">
        <img src="/img/about-us/team.jpg" alt="تیم پذیرش۲۴" width={1244} height={501} className="w-full h-auto" />
        <Paragraphs items={betterWorld} />
      </LegalSectionCard>

      <LegalSectionCard title="داستان ما">
        <div className="flex justify-center pt-4">
          <img
            src="/img/about-us/abolfazl-sajedi.jpg"
            alt="ابوالفضل ساجدی"
            width={180}
            height={180}
            loading="lazy"
            className="w-28 h-28 rounded-full"
          />
        </div>
        <Paragraphs items={ourStory} />
        <div className="px-4 pb-4 md:px-5">
          <a
            href="https://t.me/Absajedi"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold leading-6 text-primary transition hover:opacity-80"
          >
            ارتباط مستقیم با ابوالفضل ساجدی
          </a>
        </div>
        <img
          src="/img/about-us/founders.jpg"
          alt="بنیان‌گذاران پذیرش۲۴"
          width={1080}
          height={720}
          loading="lazy"
          className="w-full h-auto"
        />
      </LegalSectionCard>

      <LegalSectionCard title="حامیان، همکاران و مجوزها">
        <div className="flex flex-wrap items-center justify-center gap-4 p-4 md:p-5">
          {licenses.map(({ src, alt, href }) => {
            const logo = <img src={`/img/about-us/logos/${src}`} alt={alt} title={alt} width={80} height={80} loading="lazy" />;
            return href ? (
              <a key={src} href={href} target="_blank" rel="noopener noreferrer">
                {logo}
              </a>
            ) : (
              <span key={src}>{logo}</span>
            );
          })}
          <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=6915&Code=uwXhNitKjj0WnOAOR2I8W0Hi1jCsT1zN">
            <img
              referrerPolicy="origin"
              src="https://trustseal.enamad.ir/logo.aspx?id=6915&Code=uwXhNitKjj0WnOAOR2I8W0Hi1jCsT1zN"
              alt="نماد اعتماد الکترونیکی"
              width={80}
              height={80}
              loading="lazy"
            />
          </a>
        </div>
      </LegalSectionCard>
    </LegalPageLayout>
  );
};

export default AboutUs;
